import { mapGetters } from 'vuex';
import {
  VITE_ENV_DEVELOPMENT,
} from '@/app/data/general_constants';

const can_open_implicitly_mixin = {
  computed: {
    ...mapGetters([
      'current_is_impersonation',
      'current_is_demo',
    ]),
    can_open_implicitly() {
      return !this.current_is_impersonation || this.current_is_demo || import.meta.env.VITE_ENV === VITE_ENV_DEVELOPMENT;
    },
  }
}

export default can_open_implicitly_mixin;
